export default __webpack_public_path__ + "static/media/Brew of Vigorous Brawn.6a1521e9.jpg";